import { render, staticRenderFns } from "./imgix-lazy.vue?vue&type=template&id=387a1fe6&scoped=true&lang=pug"
import script from "./imgix-lazy.vue?vue&type=script&lang=ts"
export * from "./imgix-lazy.vue?vue&type=script&lang=ts"
import style0 from "./imgix-lazy.vue?vue&type=style&index=0&id=387a1fe6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387a1fe6",
  null
  
)

export default component.exports